import * as ResourceApi from 'api/resources';

export default {
    subSection: true,
    resource: false,
    hideIfResourceIsNoU: false,
    showSection: (formProxy) => {
        return formProxy.currentResource.resourceId.type === ResourceApi.Types.StoreFinderStep
    },

    fields: [
        {
            type: 'contenteditable',
            name: 'headline',
            required: true,
            // Headline is only allowed if there is more than one step
            showField: (proxy) => (proxy.currentResource.type === 'STORE_FINDER' && proxy.currentBaseResource.steps && proxy.currentBaseResource.steps.length > 1),
            linkedField: (formProxy) => ["title"],
            props: {
                labelKey: 'editbreak.steps.store_finder.headline'
            }
        },
        {
          type: 'image',
          name: 'clientIconId',
          idFor: 'clientIcon',
          required: false,
          showField: (proxy) => (proxy.currentResource.type === 'STORE_FINDER'),
          props: {
            labelKey: 'editbreak.steps.store_finder.custom_icon',
            imageType: 'customMapIcon'
          }
        },
        {
            type: 'contenteditable',
            name: 'introCopy',
            required: false,
            showField: (proxy) => (proxy.currentResource.type === 'STORE_FINDER'),
            props: {
              labelKey: 'editbreak.steps.store_finder.intro_copy',
              maxLength: 500,
              placeholderKey: 'editbreak.steps.store_finder.intro_copy.placeholder',
              validationRules: [
                  {
                      type: 'MarkupTextLimit',
                      params: {
                          limit: 500
                      }
                  }
              ]
            }
        },
        {
            type: 'contenteditable',
            name: 'description',
            required: false,
            showField: (proxy) => (proxy.currentResource.type === 'STORE_FINDER'),
            props: {
              labelKey: 'editbreak.steps.store_finder.body_copy',
              placeholderKey: 'editbreak.steps.store_finder.body_copy.placeholder'
            }
        },
        {
          type: 'number',
          name: 'zoomLevel',
          required: true,
          showField: (proxy) => (proxy.currentResource.type === 'STORE_FINDER'),
          props: {
            labelKey: 'editbreak.steps.store_finder.zoom_level',
            min: 0,
            max: 15
          }
        },
        {
          type: 'text',
          name: 'client',
          required: true,
          showField: (proxy) => (proxy.currentResource.type === 'STORE_FINDER'),
          props: {
            labelKey: 'editbreak.steps.store_finder.client_id'
          }
        },
        {
          type: 'storeLocationImporter',
          name: 'locationsCsv',
          required: true,
          showField: (proxy) => (proxy.currentResource.type === 'STORE_FINDER'),
          props: {
            labelKey: 'some csv key'
          }
        }
    ]
}



// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/steps/store-finder.js